import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { TextFileReader } from "../../../components/TextFileReader";
import * as toGeoJson from "@tmcw/togeojson";
import { Download } from "../../../components/Icons";
import { Icon } from "../../../components/core/Icon";
import { If } from "shared/components/control-statements";
import { Button, Label, Loading, Message } from "@components";

export default class KMLPaymentDrawer extends React.Component {
  state = {
    loading: false,
    loadingPage: true,
    active: true,
    paymentPolygons: [],
  };

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const paymentPolygons = await EnvironmentsAPI.getConfigurationsByAlias(
      holdingId,
      "payment_polygons"
    );

    this.setState({
      paymentPolygons: Array.isArray(paymentPolygons) ? paymentPolygons : [],
      loadingPage: false,
    });
  }

  async parseKml({ name, content }) {
    const kml = new DOMParser().parseFromString(content, "application/xml");
    const converted = toGeoJson.kml(kml);

    const extractGeometry = ({ name, description, geometry }) => {
      const polyGeometry = geometry.coordinates[0];
      const points = polyGeometry.map((coord) => [coord[1], coord[0]]);
      return { name: name, price: +description, points };
    };

    const features = converted.features;
    const polyArray = [];

    for (const feature of features) {
      const name = feature?.properties?.name;
      const description = feature?.properties?.description;

      if (feature.geometry.type === "Polygon") {
        polyArray.push(
          extractGeometry({ name, description, geometry: feature.geometry })
        );
      } else if (feature.geometry.type === "GeometryCollection") {
        polyArray.push(
          ...feature.geometry.geometries.map((geometry, index) => {
            const sub_name = `${name} ${index}`;
            return extractGeometry({ name: sub_name, description, geometry });
          })
        );
      }
    }

    this.setState({ paymentPolygons: polyArray });
  }

  async saveLimit(remove = false) {
    const { paymentPolygons } = this.state;
    this.setState({ loading: true });

    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();

    const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      holdingId,
      "payment_polygons",
      { payment_polygons: remove ? [] : paymentPolygons }
    );

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    } else {
      alert({
        text: "Limites de pagamento com cartão salvo com sucesso",
        buttonText: "Ok",
      });
    }

    this.setState({ loading: false });
  }

  formatBytes(bytes, decimals = 2) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["bytes", "kb", "mb"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  render() {
    const { loading, loadingPage, paymentPolygons } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Restrição geográfica de pagamento (KML)"
      >
        {loadingPage && (
          <div className="d-flex justify-center align-center h-100">
            <Loading />
          </div>
        )}
        {!loadingPage && (
          <div className={styles.secretDrawerContainer}>
            <Message className="w-100 mb-20">
              Carregue arquivos KML e restrinja endereços inseridos de utilizar
              pagamento online
            </Message>

            <TextFileReader
              allowedFiles={".kml"}
              label={"Importar novo arquivo KML"}
              onFileLoaded={this.parseKml.bind(this)}
              deliveryPolygons={paymentPolygons}
              saveDeliveryLimit={() => this.saveLimit()}
              filePattern={"text/kml"}
              uploadedFile={paymentPolygons.length > 0}
            />

            {paymentPolygons.length > 0 && (
              <div className="mt-20">
                <Label>Arquivos (1)</Label>

                <div className={styles.uploadedFile}>
                  <div className={styles.icon}>
                    <Icon name="file" light size="sm" />
                  </div>

                  <div className="d-flex flex-column w-100">
                    <p className={styles.fileName}>Nome do arquivo</p>
                    <p className={styles.fileSize}>{this.formatBytes(0)}</p>
                  </div>

                  <div className="d-flex align-center">
                    <div className={styles.download}>
                      <Download />
                    </div>
                    <div
                      className={styles.remove}
                      onClick={() => {
                        this.setState({ paymentPolygons: [] });
                      }}
                    >
                      <Icon name="times" size="sm" />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className={styles.footer}>
              <Button
                design="primary"
                className="w-100"
                onClick={() => this.saveLimit()}
                loading={loading}
                disabled={loading}
              >
                Salvar
              </Button>
            </div>
          </div>
        )}
      </Drawer>
    );
  }
}
